import React, { useEffect, useState } from "react"
import useMediaQuery from "./../../../shared/utils/useMediaQuery"
import useGetSegment from "../../../shared/utils/useGetSegment"

import "./popup-articles-campaigns.scss"
export default function PopupArticlesFemaleCare({ campaigns }) {
  const [campaign, setCampaign] = useState()
  const [isTargetedCampaign, setIsTargetedCampaign] = useState()
  const [isShowing, setIsShowing] = useState(false)
  const isMobile = useMediaQuery()
  const [, setSomeSegmentList, IsSomeSegment] = useGetSegment()

  const handleSaveView = () => {
    if (campaign && campaign.idCampana !== null) {
      localStorage.setItem(`F_ARTICLES_POPUP_${campaign.idCampana}`, new Date())
      setIsShowing(() => false)
    }
  }

  const handleButtonRedirect = () => {
    try {
      let redirectTo = campaign.recursos[0].redireccion
      if (redirectTo) {
        handleSaveView()
        window.location.href = redirectTo
      }
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    if (campaigns) {
      if (campaigns[0]) {
        // Condicionado a una sola campaña {[0]}
        setCampaign({ ...campaigns[0] })
      }
    }
  }, [])

  useEffect(() => {
    if (campaign) {
      if (Array.isArray(campaign.segmentoCampana)) {
        setIsTargetedCampaign(() => true)
        let segmentList = campaign.segmentoCampana.map(
          __segment => __segment.nombreEtiqueta
        )
        setSomeSegmentList(() => segmentList)
      }
    }

    return () => {
      setSomeSegmentList(() => undefined)
      setIsTargetedCampaign(() => undefined)
    }
  }, [campaign])

  useEffect(() => {
    if (campaign) {
      let validCountryRestrictions = !countryIsRestricted(
        campaign.paisesDeRestriccionCampana
      )
      let validIsNotShowed = !popupIsShowed(campaign.idCampana)
      let validSegment = isTargetedCampaign ? IsSomeSegment : true
      let validTimeExpire = timeIsBeforeToDay(campaign.fechaFin)
      setIsShowing(
        () =>
          validCountryRestrictions &&
          validIsNotShowed &&
          validSegment &&
          validTimeExpire
      )
    }
    return () => {
      setIsShowing(() => false)
    }
  }, [campaign, isTargetedCampaign, IsSomeSegment])

  if (!campaign || !isShowing) {
    return null
  }
  return (
    <div className="f-popup-articles-campaigns">
      <div className="f-popup-articles-campaigns__container">
        <button
          className="f-popup-articles-campaigns__container__btn-close"
          onClick={handleSaveView}
        >
          <span className={"f-icon icon2-close"}></span>
        </button>
        <button
          className="f-popup-articles-campaigns__container__btn-redirect"
          onClick={handleButtonRedirect}
        >
          <img
            className="f-popup-articles-campaigns__container__img"
            src={
              campaign.recursos[0].imagenesDeBanner[isMobile ? 1 : 0].file.url
            }
            alt={
              campaign.recursos[0].imagenesDeBanner[isMobile ? 1 : 0].file.url
            }
          />
        </button>
      </div>
    </div>
  )
}

function timeIsBeforeToDay(time) {
  try {
    let expire = new Date(time)
    let today = new Date()
    return today < expire
  } catch (e) {
    console.log(e)
    return false
  }
}

function countryIsRestricted(restrictionList) {
  try {
    let isRestricted = restrictionList.some(item => {
      return item === process.env.LOCALE.split("-")[1]
    })
    return isRestricted
  } catch (error) {
    return true
  }
}

function popupIsShowed(campaignID) {
  try {
    // /* TODO: ¿FRECUENCIA?({null} sin frecuencia):
    //     Usar un parametro que contenga una frecuencia
    //     en segundos para volver a mostrar la campaña, validando en localstorage
    // */
    let isShowed = localStorage.getItem(`F_ARTICLES_POPUP_${campaignID}`)
    return !!isShowed
  } catch (e) {
    console.log(e)
    return true
  }
}
